/* Product Carousell Block JS File */
import tab from 'bootstrap';
$(document).ready(function() {
	$('.product-carousel-tab').tab();
});
